import VueSvgInlinePlugin from 'vue-svg-inline-plugin'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueSvgInlinePlugin)
})
